<template>
  <footer class="container row u-full-width">

    <div class="copyright">&copy; 2019 Thisism</div>
    <div class="links">

      <a href="https://www.instagram.com/thisism_ig/?hl=ja" target="_blank"><i class="fa fa-instagram"
                                                                               aria-hidden="true"></i></a>
      <a href="https://twitter.com/thisismtwt" target="_blank"><i class="fa fa-twitter" aria-hidden="true"></i></a>
    </div>
  </footer>
</template>

<script>
  export default {}
</script>

<style lang="scss" scoped>

  @import "../style/common";

  a {
    text-decoration: none;
    &:link {
      color: $color_white;
    }
    &:visited {
      color: $color_white;
    }
  }

  $bar_height: 100px;

  footer {
    margin-top: 20px;
    height: $bar_height;
    width: 100%;
  }

  .copyright {
    float: left;
    width: 30%;
    line-height: $bar_height;
    text-align: left;
    padding-left: 20px;
    font-size: 1.5rem;
  }

  .links {
    float: right;
    width: 30%;
    line-height: $bar_height;
    text-align: right;
    padding-right: 20px;
    font-size: 3rem;

    i {
      margin: 0 2px;
      &:hover {
        font-size: 3.5rem;
      }
    }

  }

</style>



// WEBPACK FOOTER //
// Footer.vue?05f0e0d8